/**
 * This function uses enum reverse mapping to return the name of a given enum value.
 *
 * NOTE: Keep in mind that string enum members do not get a reverse mapping generated at all.
 *
 * Usage:
 *     const errorName = getEnumKey(HttpStatusCode, HttpStatusCode.FORBIDDEN);
 *     if (errorName === 'FORBIDDEN') {
 *       // This evaluates to true.
 *     }
 *
 * @see: https://www.typescriptlang.org/docs/handbook/enums.html#reverse-mappings
 */
export function getNumericEnumKeyName<T>(enumReference: any, enumKey: T): keyof T {
  return enumReference[enumKey];
}
